import { render, staticRenderFns } from "./companyMerchantNetModify.vue?vue&type=template&id=b57504da&scoped=true&"
import script from "./companyMerchantNetModify.vue?vue&type=script&lang=js&"
export * from "./companyMerchantNetModify.vue?vue&type=script&lang=js&"
import style0 from "./companyMerchantNetModify.vue?vue&type=style&index=0&id=b57504da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57504da",
  null
  
)

export default component.exports